import { useRouter } from 'next/router';

//Utils
import useCurrentSession from '@/utils/hooks/user/useCurrentSession';

//Components
import LoaderPage from '@/components/base/Loader/LoaderPage';

import { SIGN_IN } from '@/routes/publicRoutes';

export default function Homepage() {
    const router = useRouter();
    const { user, isLoading } = useCurrentSession({ isLoggedRedirect: true });

    if (!isLoading && !user) {
        router.push({
            pathname: SIGN_IN
        });
    }

    return <LoaderPage />;
}
